import { render, staticRenderFns } from "./RumourReader.vue?vue&type=template&id=65f29ec4"
import script from "./RumourReader.vue?vue&type=script&lang=js"
export * from "./RumourReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f29ec4')) {
      api.createRecord('65f29ec4', component.options)
    } else {
      api.reload('65f29ec4', component.options)
    }
    module.hot.accept("./RumourReader.vue?vue&type=template&id=65f29ec4", function () {
      api.rerender('65f29ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourReader.vue"
export default component.exports